import { render } from "./VisitList.vue?vue&type=template&id=3deb1ce0"
import script from "./VisitList.vue?vue&type=script&lang=js"
export * from "./VisitList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__